import { render, staticRenderFns } from "./PortfolioPpc.vue?vue&type=template&id=235f89da&scoped=true&"
var script = {}
import style0 from "./PortfolioPpc.vue?vue&type=style&index=0&id=235f89da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235f89da",
  null
  
)

export default component.exports